import React from "react";
import { twMerge } from "tailwind-merge";

enum InputSizeOptions {
  "sm",
  "default",
  "lg",
  "np",
}
export type TextareaTypeOptionType = keyof typeof InputSizeOptions;

export const InputSizes: Record<string, string> = {
  sm: "py-2",
  default: "py-3",
  lg: "py-4",
  np: "p-0",
};

export interface TextareaProps extends React.HTMLProps<HTMLTextAreaElement> {
  labelText?: string;
  inputSize?: TextareaTypeOptionType;
  inputRef?: React.Ref<HTMLTextAreaElement> | null;
}

const Textarea: React.FunctionComponent<
  React.PropsWithChildren<TextareaProps>
> = ({
  labelText = "",
  placeholder = "Type here...",
  inputSize = "default",
  inputRef = null,
  name,
  className,
  ...rest
}) => {
  return (
    <div>
      {labelText ? (
        <label
          htmlFor={name}
          className="block leading-9 truncate mb-1 text-white"
        >
          {labelText}
        </label>
      ) : null}
      <div className="relative rounded-md">
        <textarea
          className={twMerge(
            "text-sm border border-gray-300 rounded w-full px-4 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none resize-none",
            InputSizes[inputSize],
            className
          )}
          placeholder={placeholder}
          ref={inputRef}
          name={name}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          {...(rest as any)}
        />
      </div>
    </div>
  );
};

export default Textarea;
